var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338.28 73.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}.cls-2{fill:none;stroke:#a37b50;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.36,
    cy: 44.64,
    rx: 19.39,
    ry: 62.59,
    transform: "translate(4.98 95.43) rotate(-78.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 276.47,
    cy: 44.42,
    rx: 62.59,
    ry: 19.39,
    transform: "translate(-3.54 46.34) rotate(-9.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.11.83c14,21,18,61,9,71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.36,1.21c-14,21-18,61-9,71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset43);
export default __webpack_public_path__ + "static/media/Asset 43.1a98579e.svg";
export { ForwardRef as ReactComponent };